import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, OnInit, Output, Renderer2, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PdfService } from 'src/app/services/pdf.service'
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() pdfUrl: string | undefined;
  @Input() pdfFileName: string | undefined;
  @Input() embedMode: EmbedMode | undefined;
  @Output() documentReadEvent: EventEmitter<boolean> = new EventEmitter();

  documentReadEventSubscription: Subscription | undefined;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private pdfService: PdfService,
    private renderer: Renderer2,
    private configService: ConfigService) { }
  
  ngOnInit(): void {
    this.appendScript(this.configService.config.adobeViewSdkScriptUrl);
    this.documentReadEventSubscription = this.pdfService.documentReadEvents$.subscribe(x => {
      if (this.pdfFileName === x) {
        this.documentReadEvent.emit(true);
      }
    });
  }

  ngAfterViewInit() {
    this.pdfService.ready().then(() => {
      let url = this.pdfUrl || '';
      let fileNameFromUrl = url.replace(/^.*[\\\/]/, '');
      this.pdfFileName = fileNameFromUrl;
      let viewerConfig = (this.embedMode === EmbedMode.FULL_WINDOW) ? {} : { embedMode: this.embedMode?.toString() };
      this.pdfService.previewFile(this.pdfUrl ?? '', this.pdfFileName ?? fileNameFromUrl, 'pdf-div', viewerConfig);
    });
  }

  ngOnDestroy(): void {
    if (this.documentReadEventSubscription) {
      this.documentReadEventSubscription.unsubscribe();
    }
  }

  private appendScript(url: string) {
    let scriptElement = this.renderer.createElement("script");
    scriptElement.type = "text/javascript";
    scriptElement.src = url;
    this.renderer.appendChild(this.document.body, scriptElement);
  }
}

enum EmbedMode {
  IN_LINE = "IN_LINE",
  SIZED_CONTAINER = "SIZED_CONTAINER",
  FULL_WINDOW = "FULL_WINDOW",
  LIGHT_BOX = "LIGHT_BOX"
}
